import { Company } from "./pages/PublicCompany";
import promise = require('es6-promise');
import { JobListWidget } from "./widgets/JobListWidget";
import { CompanyListWidget} from "./widgets/CompanyListWidget";

promise.polyfill();





export { Company };
export { JobListWidget };
export { CompanyListWidget };
